import * as React from 'react';
const Descriptions = React.memo((props: {
  value: string;
}) => <div aria-label="Description" className="flex leading-tight line-clamp-3 pt-[5px] h-[70px]">
    {props.value || '--'}
  </div>);
Descriptions.displayName = 'Descriptions';
export default Descriptions;